<script lang="ts">
	import CheckCircleIcon from "@lucide/svelte/icons/check-circle";
	import Section from "#lib/web-ui/primitives/section.svelte";

	let {
		heading = "We Want to Buy Your House!",
		items = [
			"NO FEES",
			"NO BANKS",
			"NO SURPRISES",
			"NO COMMISSIONS",
			"NO REPAIRS",
			"NO HASSLES"
		],
		footerText
	}: {
		heading?: string;
		items?: string[];
		footerText?: string;
	} = $props();
</script>

<Section>
	<div
		class="relative overflow-hidden rounded-3xl bg-neutral-900 px-8 py-12 shadow-2xl ring-1 ring-neutral-800 sm:px-12 sm:py-16"
	>
		<!-- Decorative orange corner accent -->
		<div
			class="bg-primary absolute top-0 right-0 h-24 w-24 translate-x-8 -translate-y-8 rounded-full opacity-20 blur-2xl"
		></div>

		<!-- Content -->
		<div class="relative">
			<!-- Heading -->
			<h2
				class="text-center text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl"
				style="background: linear-gradient(135deg,
						hsl(32, 93%, 55%) 0%,
						white 20%,
						hsl(29, 92%, 55%) 40%,
						white 60%,
						hsl(32, 93%, 55%) 80%,
						white 100%);
						-webkit-background-clip: text;
						background-clip: text;
						-webkit-text-fill-color: transparent;"
			>
				{heading}
			</h2>

			<!-- Check Items Grid -->
			<div class="mx-auto mt-10 max-w-4xl">
				<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
					{#each items as item, index (index)}
						<div class="flex items-center gap-3">
							<div class="flex-shrink-0">
								<CheckCircleIcon class="text-primary h-7 w-7" />
							</div>
							<span class="text-lg font-semibold tracking-wide text-white uppercase">
								{item}
							</span>
						</div>
					{/each}
				</div>
			</div>

			<!-- Footer Text -->
			{#if footerText}
				<p class="mt-10 text-center text-base text-gray-300">
					{footerText}
				</p>
			{/if}
		</div>
	</div>
</Section>
